import { BillRepository } from "../repositories/BillRepository";
import { ZohoBillDetailsEntity } from "../entities/BillListItemEntity";

export class GetZohoBillDetailsUseCase {
  constructor(private repository: BillRepository) {}

  async execute(zohoBillId: string): Promise<ZohoBillDetailsEntity> {
    // Validate zoho bill ID
    if (!zohoBillId || zohoBillId.trim() === "") {
      throw new Error("Zoho bill ID is required");
    }

    // Execute repository call
    return await this.repository.getZohoBillDetails(zohoBillId.trim());
  }
}

